/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContactDtoModel } from '@well/domain';
import { ContactAutocompleteService } from './contact-autocomplete.service';

@Component({
  selector: 'well-contact-autocomplete',
  templateUrl: './contact-autocomplete.component.html',
  styleUrls: ['./contact-autocomplete.component.scss']
})
export class ContactAutocompleteComponent {

  @Input() placeholder: string | null = null;

  @Input() disabled = false;

  @Input() customerUuid: string | null = null;

  @Output() whenSelected: EventEmitter<ContactDtoModel> = new EventEmitter();

  results: ContactDtoModel[] = [];

  selected: ContactDtoModel | null = null;

  constructor(private service: ContactAutocompleteService) {
  }

  onQueryChange(query: string) {
    const queryObj = {
      filters: {
        contactName: {
          value: query,
          matchMode: 'contains'
        }
      }
    };

    this.service.findAll(this.customerUuid, queryObj).subscribe(res => {
      this.results = res.data;
    });
  }

  onSelectItem(item: ContactDtoModel) {
    this.selected = item;
    this.whenSelected.next(item);
  }

  onClear() {
    this.selected = null;
  }

  getDisplayName = (item: ContactDtoModel | null): string => {
    return item?.personDTO?.name ?? '';
  };

  compareByUuid = (a: ContactDtoModel, b: ContactDtoModel): boolean => {
    return a?.uuid === b?.uuid;
  };
}
